/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineResponse2007 model module.
 * @module model/InlineResponse2007
 * @version 1.0.0
 */
class InlineResponse2007 {
    /**
     * Constructs a new <code>InlineResponse2007</code>.
     * @alias module:model/InlineResponse2007
     */
    constructor() { 
        
        InlineResponse2007.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse2007</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse2007} obj Optional instance to populate.
     * @return {module:model/InlineResponse2007} The populated <code>InlineResponse2007</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse2007();

            if (data.hasOwnProperty('id_attribute')) {
                obj['id_attribute'] = ApiClient.convertToType(data['id_attribute'], 'String');
            }
            if (data.hasOwnProperty('id_product_attribute')) {
                obj['id_product_attribute'] = ApiClient.convertToType(data['id_product_attribute'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('image')) {
                obj['image'] = ApiClient.convertToType(data['image'], 'String');
            }
        }
        return obj;
    }


}

/**
 * ID del atributo
 * @member {String} id_attribute
 */
InlineResponse2007.prototype['id_attribute'] = undefined;

/**
 * ID del producto atributo
 * @member {String} id_product_attribute
 */
InlineResponse2007.prototype['id_product_attribute'] = undefined;

/**
 * Nombre del certificado
 * @member {String} name
 */
InlineResponse2007.prototype['name'] = undefined;

/**
 * URL de la imagen del certificado
 * @member {String} image
 */
InlineResponse2007.prototype['image'] = undefined;






export default InlineResponse2007;

